export interface Enviroment {
  apiUrl: string;
  pixApiUrl: string;
  isMock: boolean;
  appVersion: string;
  appInsightsConString: string;
  supabaseAnonKey: string;
}
const enviroment = {
  apiUrl: process.env.REACT_APP_API_URL,
  pixApiUrl: process.env.REACT_APP_PIX_API_URL,
  isMock: process.env.REACT_APP_IS_MOCK as unknown as boolean,
  appVersion: process.env.REACT_APP_VERSION,
  appInsightsConString: process.env.REACT_APP_CON_STRING,
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY ?? ""
} as Enviroment;
export default enviroment;

//https://create-react-app.dev/docs/adding-custom-environment-variables/
